import React, { useEffect } from "react";

import "./styles.css";
import PropTypes from 'prop-types';

import { Switch, Route, Router, useLocation } from "react-router-dom";

import { history } from "./helpers";

import { connect } from "react-redux";
import Cookies from "universal-cookie";
import * as QueryString from "query-string";
import { userActions } from "./actions";

import { Menu } from "components/nav/Menu";
import { PrivateRoute } from "./components/routing/PrivateRoute";
import { UploadJacket } from "./components/upload/UploadJacket";
import { LoginPage } from "./components/authentication/LoginPage";
import { MfaPage } from "./components/authentication/MfaPage";
import { AlertArea } from "./components/common/AlertArea";
import { OrgList } from "./components/org/OrgList";
import { ScrapeRequest } from "./components/ingestor/ScrapeRequest";
import { RenderRequest } from "./components/ingestor/RenderRequest";
import { DispatchRequest } from "./components/ingestor/DispatchRequest";
import { RetrieveRequest } from "./components/ingestor/RetrieveRequest";
import { ClassifyRequest } from "./components/ingestor/ClassifyRequest";
import { IngestionRunDetail } from "./components/ingestor/IngestionRunDetail";
import { OrgLayout } from "./components/routing/OrgLayout";
import { UserLayout } from "./components/routing/UserLayout";
import { ForgotPassword } from "./components/user/ForgotPassword";
import { PasswordReset } from "./components/authentication/PasswordReset";
import { Contact } from "./components/common/Contact";
import { OrgBanner } from "./components/common/OrgBanner";
import { ScanPage } from "./components/scan/ScanPage";
import { TermsOfService } from "./components/common/TermsOfService";



function App(props) {
  //console.log(props);
  const { authentication, tokenLogin, location } = props;
  const logo = require("./images/icon.png").default;
  const logotext = require("./images/logo-text.png").default;

  const hlocation = useLocation();
  //console.log("react-router-dom location: "+JSON.stringify(hlocation));
  const searchParams = new URLSearchParams(hlocation.search);
  //const searchParams = QueryString.parse(hlocation.search);
  const params = QueryString.parse(location?.search);
  const code = params.pwrc;
  const token = searchParams.get("jwt");
  //const token = searchParams.jwt;
  //console.log("token: "+token);


  if (code !== undefined) {
    //console.log("code received from props location")
    history.push("/pwdreset?c=" + code);
  }

  useEffect(() => {
    const cookies = new Cookies();
    const uid = cookies.get("uid");

    if (uid) {
      // cookieLogin(uid, window.location.pathname);
    }
    if (!authentication?.user?.email && token) {
      //console.log("token received from react-router-dom: ");
      //console.log(token);
      tokenLogin(token, hlocation);
    }
  });




  return (
    <>
      <div className="App">
        <header>
          <div className="logos">
            <img src={logo} height="120" alt="Tag Tech logo" />
            <img src={logotext} height="60" alt="Tag Tech, LLC" />
          </div>
          <OrgBanner />
        </header>

        <Router history={history}>
          <Menu />
          <AlertArea />
          <Switch>
            <Route path="/pwd_change" component={ForgotPassword} />
            <Route path="/pwdreset" component={PasswordReset} />
            <Route exact path="/index.html" component={LoginPage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/mfa" component={MfaPage} />

            {!authentication?.user?.email && (
              <Route exact path="/contact" component={Contact} />
            )}

            {authentication?.user?.email && (
              <>
                <Route path="/org/:id">
                  <OrgLayout />
                </Route>
                <Route path="/user">
                  <UserLayout />
                </Route>
                <Route path="/users">
                  <UserLayout />
                </Route>
                <Route path="/tos">
                  <TermsOfService />
                </Route>
                <PrivateRoute exact path="/upload" component={UploadJacket} />
                <PrivateRoute exact path="/upload-browse" component={UploadJacket} />
                <PrivateRoute exact path="/orgs" component={OrgList} />
                <PrivateRoute
                  exact
                  path="/ingestion/scrape"
                  component={ScrapeRequest}
                />
                <PrivateRoute
                  exact
                  path="/ingestion/render"
                  component={RenderRequest}
                />
                <PrivateRoute
                  exact
                  path="/ingestion/dispatch"
                  component={DispatchRequest}
                />
                <PrivateRoute
                  exact
                  path="/ingestion/retrieve"
                  component={RetrieveRequest}
                />
                <PrivateRoute
                  exact
                  path="/ingestion/classify"
                  component={ClassifyRequest}
                />
                <PrivateRoute
                  exact
                  path="/ingestion/run/:id"
                  component={IngestionRunDetail}
                />
                <Route path="/dwt">
                  <ScanPage />
                </Route>
              </>
            )}
            <Route path="/" component={LoginPage} />
          </Switch>
        </Router>
        <br />
        <br />
        <footer className="footer">&copy; 2020 Tag Tech, LLC</footer>
      </div>
    </>
  );
}

App.propTypes = {
  authentication: PropTypes.object,
  location: PropTypes.object
}

function mapStateToProps(state) {
  const { authentication, location } = state;
  return {
    authentication,
    location
  };
}

const actionCreators = {
  cookieLogin: userActions.cookieLogin,
  tokenLogin: userActions.tokenLogin,
};

const connectedApp = connect(mapStateToProps, actionCreators)(App);
export { connectedApp as App };
